module.exports = __webpack_public_path__ + "img/register-image.3955ac68.svg";